import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import FormButtons from '../../components/FormButtons';
import Select from '../../components/Select';
import { DescriptionForm } from '../../components/styled';
import useFields from '../../hooks/useFields';
import { formatValuesLoad } from '../index/values';

interface LivingPlaceProps {
  idRequest: number;
  save: (
    formName: string,
    fields: any,
    isComplete: boolean,
    save: boolean
  ) => void;
  next: () => void;
}

const LivingPlace = (props: LivingPlaceProps) => {
  const { idRequest, next, save } = props;
  const [validateForm, setValidateForm] = useState(0);
  const formBse = useSelector((state: any) => state.getFormBse);
  const { formLivingPlace } = formatValuesLoad(formBse?.data);
  const { fields, setFieldValue, formIsValid, formIsComplete, formIsEmpty } =
    useFields(formLivingPlace);
  const { livingPlacePertenencia, livingPlaceEstado } = fields;

  const saveForm = () => {
    setValidateForm(validateForm + 1);
    save('livingPlace', fields, formIsComplete, true);
  };

  React.useEffect(() => {
    if (idRequest > 0 && !formIsEmpty) {
      save('livingPlace', fields, formIsComplete, false);
    }
  }, [idRequest, formIsEmpty]);

  if (!formBse?.data) return null;

  return (
    <div data-testid="cmp-bse-form-living" style={{ padding: '16px 24px' }}>
      <DescriptionForm>
        Cuéntanos cómo se encuentra tu vivienda actualmente.
      </DescriptionForm>
      <Select
        nameLabel="Pertenencia"
        value={livingPlacePertenencia}
        name="livingPlacePertenencia"
        optionsList={formBse?.data?.[77]?.dropDownList} // Using optional chaining
        placeholder="Selecciona tu pertenencia"
        setFieldValue={setFieldValue}
        validateOnStart={idRequest ? idRequest > 0 && !formIsEmpty : false}
        validateForm={validateForm}
      />

      <Select
        nameLabel="Estado de construcción"
        value={livingPlaceEstado}
        name="livingPlaceEstado"
        optionsList={formBse?.data?.[64]?.dropDownList} // Using optional chaining
        placeholder="Selecciona tu estado"
        setFieldValue={setFieldValue}
        validateOnStart={idRequest ? idRequest > 0 && !formIsEmpty : false}
        validateForm={validateForm}
        top
      />
      {/* <Select
        nameLabel="Distribución de familiares por habitación"
        value={livingPlaceDistribucion}
        name="livingPlaceDistribucion"
        optionsList={formBse?.data?.[65]?.dropDownList} // Using optional chaining
        placeholder="Selecciona tu distribución"
        setFieldValue={setFieldValue}
        validateOnStart={idRequest ? idRequest > 0 && !formIsEmpty : false}
        validateForm={validateForm}
        top
      /> */}
      <FormButtons
        handlerSend={saveForm}
        handlerNext={next}
        formIsValid={formIsValid}
      />
    </div>
  );
};

export default LivingPlace;
